import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SectionDivider } from '../components/SectionDivider';
import { PainPointsSection } from '../components/PainPointsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { ServicesSection } from '../components/ServicesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FooterCTA } from '../components/FooterCTA';
export function HomePage() {
  return <>
      <HeroSection data-id="element-398" />
      <SectionDivider data-id="element-399" />
      <PainPointsSection data-id="element-400" />
      <SectionDivider data-id="element-401" />
      <AboutSection data-id="element-402" />
      <SectionDivider data-id="element-403" />
      <MethodSection data-id="element-404" />
      <SectionDivider data-id="element-405" />
      <ServicesSection data-id="element-406" />
      <SectionDivider data-id="element-407" />
      <ResourcesSection data-id="element-408" />
      <SectionDivider data-id="element-409" />
      <TestimonialsSection data-id="element-410" />
      <SectionDivider data-id="element-411" />
      <FooterCTA data-id="element-412" />
    </>;
}